<template>
  <div class="porduct-div">
    <!-- logo -->
    <div class="pro-pic">
      <img
        src="../assets/images/icon/renoud-logo-blue.png"
        style="width: 100%"
      />
    </div>
    <!-- 产品列表 -->
    <el-row>
      <div class="pro-list" id="proid" style="justify-content: space-around;">
        <el-col
          :span="8"
          v-for="(item, index) in showList"
          :key="index"
          @click="toAir()"
          style="z-index: 11"
        >
          <div class="list-corlor">
            <router-link :to="{ name: 'air', params: { tabId: item.tabId } }">
              <div class="pro_box">
                <img :src="item.url" style="width: 100%" />
              </div>
              <div class="pro-biaoti">
                {{ item.title }}<br />{{ item.main }}
              </div>
            </router-link>
          </div>
        </el-col>
      </div>
    </el-row>
    <!-- 左右箭头 -->
    <div class="pro-jiantou">
      <div class="arrow_left" @click="dianji(1)">
        <img class="pro_arrow" src="../assets/images/icon/jiantou-zuo.png" />
      </div>
      <div class="arrow_right" @click="dianji(2)">
        <img class="pro_arrow" src="@/assets/images/icon/jiantou-you.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["list"],
  computed: {
    showList: {
      get() {
        let list = this.list;
        let res = [];
        if (list.length > 2) {
          res.push(list[this.showIndexs[0]]);
          res.push(list[this.showIndexs[1]]);
          // res.push(list[this.showIndexs[2]]);
        }
        return res;
      },
    },
  },
  data: () => ({
    showIndexs: [0, 1, 2],
  }),
  methods: {
    dianji(type) {
      if (type === 1) {
        if (this.showIndexs[0] === 0) {
          // this.$message.closeAll();
          // this.$message("已经是第一张啦！", 1);
          return false;
        }
        this.showIndexs = this.showIndexs.map((element) => element - 1);
      } else {
        if (this.showIndexs[2] + 1 === this.list.length) {
          // this.$message.closeAll();
          // this.$message("已经是第最后一张啦！", 1);
          return false;
        }
        this.showIndexs = this.showIndexs.map((element) => element);
      }
    },
    // 跳转Air
    toAir() {
      this.$router.push({
        path: "/air",
      });
    },
  },
};
</script>

<style scoped>
/* ------------- mobile端样式(屏幕小于960px) ------------- */
@media only screen and (max-width: 960px) {
  /* logo */
  .pro-pic {
    width: 18%;
  }
  /* 产品 */
  .pro-biaoti {
    font-size: 35px;
    color: #333333;
  }
  .pro_box {
    width: 82%;
    margin: 0 auto;
  }
  /* 箭头图标 */
  .pro-jiantou {
    position: absolute;
    bottom: 22%;
    width: 95%;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
  }
  .pro_arrow {
    width: 55%;
    height: 100%;
  }
  .arrow_left {
    cursor: pointer;
    width: 220px;
height: 220px;
  }
  .arrow_right {
    cursor: pointer;
    width: 220px;
height: 220px;
  }
}
/* ------------- pc端样式(屏幕大于960px) ------------- */
@media only screen and (min-width: 960px) {
  /* logo */
  .pro-pic {
    width: 11%;
  }
  /* 产品 */
  .pro-biaoti {
    font-size: 25px;
    color: #bbbaba;
  }
  .pro_box {
    width: 72%;
    margin: 0 auto;
  }
  /* 箭头图标 */
  .pro-jiantou {
    position: absolute;
    bottom: 10%;
    width: 100%;
    width: 100%;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
  }
  .pro_arrow {
    width: 75%;
  }
  .arrow_left {
    padding-left: 80px;
    cursor: pointer;
  }
  .arrow_right {
    padding-right: 80px;
    cursor: pointer;
  }
}

/* 第三部分  产品 */
.porduct-div {
  position: relative;
  box-sizing: border-box;
}
/* logo */
.pro-pic {
  margin: 0 auto;
  margin-top: 35px;
}
/* 产品列表 */
.pro-list {
  display: flex;
  flex-wrap: wrap;
  width: 70%;
  margin: 0 auto;
  padding-top: 80px;
  z-index: 99;
}
.list-corlor {
  width: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.pro-biaoti {
  text-align: center;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 30px;
  margin-bottom: -54px;
  font-family: "Gotham-Book";
  letter-spacing: 4px;
  cursor: pointer;
}
/* 箭头 */
.pro-jiantou {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/TransverseRotation.vue